import { Component, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { LanguageService } from './core/i18n/language.service';
import { InactivityService } from './core/session/inactivity.service';
import { ThemeService } from './core/theme/theme.service';
import { SessionExpiredModalComponent } from './shared/components/session-expired-modal/session-expired-modal.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, SessionExpiredModalComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  private language = inject(LanguageService);
  private theme = inject(ThemeService);
  private inactivity = inject(InactivityService);
  private router = inject(Router);

  constructor() {
    this.theme.init();
    this.language.init();
    this.inactivity.init();
  }

  get sessionExpired(): boolean {
    return this.inactivity.expired();
  }

  onSessionReconnect(): void {
    const loginUrl = this.inactivity.loginRedirectUrl();
    this.inactivity.acknowledge();
    void this.router.navigateByUrl(loginUrl);
  }
}
